import React, { forwardRef, useCallback } from 'react';

// Wrapper for a component that adds a keypress handler that invokes onClick if the component
// receives an Enter or Space keypress.
export default function withEnterToClick(Component) {
  const Wrapped = ({ onClick, onKeyPress, forwardedRef, ...otherProps }) => {
    const localOnKeyPress = useCallback(
      e => {
        if (e.key === 'Enter' || e.key === ' ') {
          if (onKeyPress) onKeyPress(e);
          if (onClick) onClick(e);
          e.preventDefault();
        }
      },
      [onKeyPress, onClick],
    );

    return (
      <Component
        ref={forwardedRef}
        {...otherProps}
        onClick={onClick}
        onKeyPress={localOnKeyPress}
      />
    );
  };

  const forward = (props, ref) => <Wrapped {...props} forwardedRef={ref} />;
  const name = Component.displayName || Component.name;
  forward.displayName = `withEnterToClick(${name})`;
  return forwardRef(forward);
}
